import React from 'react'
import "./AboutBannerCards.css"

export default function AboutBannerCards(props) {
    return (
        <section className='about-banner-cards'>
            <div className="about-card ">
                <div className='logo-holder'>
                    <img src={process.env.PUBLIC_URL + props?.img} alt='card-img' className='about-card-img' />
                </div>
                <div className='content-holder'>
                    <h6>{props?.text}</h6>
                </div>
            </div>

        </section>
    )
}
